import { render, staticRenderFns } from "./AgendaPelatihanNew.vue?vue&type=template&id=6be18763&scoped=true"
import script from "./AgendaPelatihanNew.vue?vue&type=script&lang=js"
export * from "./AgendaPelatihanNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be18763",
  null
  
)

export default component.exports